<app-popin popinTitle="dashboard_report.add_widget"
           [closeIcon]="true"
           (onClose)="dialogRef.close()">
  <div content>
    <div class="widgets-wrapper">
      <div (click)="openDialog(dialogText)">
        <mat-icon>article</mat-icon>
        <div>{{ 'dashboard_report.text' | translate }}</div>
      </div>
      <div (click)="openDialog(dialogTotals)">
        <mat-icon>money</mat-icon>
        <div>{{ 'dashboard_report.totals' | translate }}</div>
      </div>
      <div (click)="openDialog(dialogAxisChart)">
        <mat-icon>line_axis</mat-icon>
        <div>{{ 'dashboard_report.axis_chart' | translate }}</div>
      </div>
      <div (click)="openDialog(dialogPieChart)">
        <mat-icon>pie_chart</mat-icon>
        <div>{{ 'dashboard_report.pie_chart' | translate }}</div>
      </div>
      <div (click)="openDialog(dialogTable)">
        <mat-icon>table_chart</mat-icon>
        <div>{{ 'dashboard_report.table' | translate }}</div>
      </div>
    </div>
  </div>
</app-popin>
